// extracted by mini-css-extract-plugin
export var offlineNotificaton = "OfflineNotification-module--offlineNotificaton--7e7f7";
export var offlineNotificaton__button = "OfflineNotification-module--offlineNotificaton__button--6e528";
export var offlineNotificaton__header = "OfflineNotification-module--offlineNotificaton__header--6b07f";
export var offlineNotificaton__text = "OfflineNotification-module--offlineNotificaton__text--3bb1d";
export var offlineNotificaton__withCookie = "OfflineNotification-module--offlineNotificaton__withCookie--0b387";